//url for testing with jsonserver, need a better solution for this
// const baseUrl = process.env.REACT_APP_API_URL + "/v1/agency-sweep/payments/";
// const baseUrl = "/v1/agency-sweep/payments/";

export default async function getPayments(
  agencyNumber: string,
  startDate: string,
  endDate: string,
  interestNumber: string,
) {
  let data: any = [];
  await fetch(
    `/api/sitecore/PaymentsAsync/GetAgencySweepReport?startDate=${startDate}&endDate=${endDate}&interestNumber=${interestNumber}&limit&offset&subAgencyNumber=${agencyNumber}`,
    { method: 'GET' },
  )
    .then((res) => res.json())
    .then(
      (result) => {
        try {
          data = JSON.parse(result)['payments'];
          if (!data) {
            data = JSON.parse(result);
          }
        } catch (err: any) {
          console.error(`${'GetAgencySweepReport'}() >> ${err.message}`);
        }
      },
      (error) => {
        console.error(`${'GetAgencySweepReport'}() >> ${error}`);
      },
    );
  return data;
}
